class Auth{
    constructor(){
        this.authenticated = false;
        this.usuario = [];
        this.nombre = '';
        this.cod_concesionario = 0;
    }

    login(cb){
        this.authenticated = true;
        cb();
    }

    logout(cb){
        this.authenticated = false;
        cb();
    }

    isAuthenticated(){
        return this.authenticated;
    }
}

export default new Auth();